import { AccountInfo } from '@azure/msal-browser';

export function checkUserAuthorization (account: AccountInfo | null, allowedRoles: string[]) {
  if (!account || !allowedRoles) {
    return true;
  }

  const userRoles = account.idTokenClaims?.roles as string[] || [];
  const userGroups = account.idTokenClaims?.groups as string[] || [];
  const userAuthorizations = [...userRoles, ...userGroups];

  return allowedRoles.length === 0 || allowedRoles.some((role) => userAuthorizations.includes(role));
}
